import React, { useContext, useEffect } from "react";
import { observer } from "mobx-react-lite";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { DepositContext } from "@state/context/payment/DepositContext";

export default observer(function DepositTransactionStatusFilterSection() {
	const { t } = useTranslation("payment");
	const { register } = useFormContext();
	const { transactionStatuses, fetchTransactionStatuses } =
		useContext(DepositContext);

	useEffect(() => {
		fetchTransactionStatuses();
	}, []);

	return (
		<div className="form__group">
			<label htmlFor="transactionStatusSelect" className="label">
				{t<string>("COMMON.STATUS")}
			</label>
			<select
				id="transactionStatusSelect"
				className="input input--med input--select"
				{...register("transactionStatusId")}
			>
				<option key="transactionStatus-all" value="all">
					{t<string>("COMMON.ALL_STATUS")}
				</option>
				{transactionStatuses?.map((transactionStatus: any) => (
					<option
						key={transactionStatus.abrv}
						value={transactionStatus.id}
					>
						{transactionStatus.name}
					</option>
				))}
			</select>
		</div>
	);
});
